import React, { useState, useContext } from "react"
import { useTranslation } from "react-i18next"
import { router } from "../../../../utility/router"
import { PageContext } from "../../Page"
import { StaticImage } from "gatsby-plugin-image"
import { ArrowLink } from "../../../basics/Link"
import { AllFoldersExcept, OnlyFolders } from "../../../utility/Folders"
import Badge from "../../../basics/Badge"
import ProductLink from "./ProductLink"

import OpenPaymentsIcon from '../../../../assets/icons/open-payments-header.svg'
import OpenBankingIcon from '../../../../assets/icons/open-banking-header.svg'
import OpenFinanceIcon from '../../../../assets/icons/open-finance-header.svg'
import InStoreIcon from '../../../../assets/icons/in-store-header.svg'
import ExternalIcon from '../../../../assets/icons/external-link.svg'

const MenuProducts = ({ closeMenuFunction = () => { } }) => {
  const context = useContext(PageContext)
  const [currentSubMenu, setCurrentSubMenu] = useState(0)
  // const [fadeClass, setFadeClass] = useState('fade-from-up')
  // const shadowHeight = 88
  // const shadowTop = shadowHeight * currentSubMenu
  const [t] = useTranslation("layout")

  const handleNavlinkClick = (menuToOpen) => {
    // setFadeClass(currentSubMenu < menuToOpen ? 'fade-from-down' : 'fade-from-up')
    setCurrentSubMenu(menuToOpen)
  }

  const SubMenuNavlink = ({ menuToOpenOnClick, children }) => {
    return <div className={`${currentSubMenu === menuToOpenOnClick ? 'bg-midnight-60' : 'bg-white'} rounded-lg transition-all p-2`}>
      <div onClick={() => handleNavlinkClick(menuToOpenOnClick)} className={`flex items-center cursor-pointer relative z-[20]`}>
        {children}
      </div>
    </div>
  }

  const Psd2Products = () => {
    return <>
      <div className="h-full px-5 pt-5 pb-3.5 products-list">
        <h5 className="text-blue-10 mb-1.5">{t('header.productsMenu.psd2Services.title')}</h5>

        <ProductLink to={router('products.psd2Services.aisp', context.folder)}
          label={t('header.productsMenu.psd2Services.aisp')}
          description={t('header.productsMenu.psd2Services.aispDesc')}
          onClick={() => closeMenuFunction()}
        />
        <ProductLink to={router('products.psd2Services.pisp', context.folder)}
          label={t('header.productsMenu.psd2Services.pisp')}
          description={t('header.productsMenu.psd2Services.pispDesc')}
          onClick={() => closeMenuFunction()}
        />
        <OnlyFolders folders={["it-it"]}>
          <ProductLink to={router('products.psd2Services.fast-scoring', context.folder)}
            label={t('header.productsMenu.psd2Services.creditRating')}
            description={t('header.productsMenu.psd2Services.creditRatingDesc')}
            onClick={() => closeMenuFunction()}
          />
        </OnlyFolders>
        <OnlyFolders folders={["it-it", "fr-fr"]}>
          <ProductLink to={router('products.psd2Services.personalFinance', context.folder)}
            label={t('header.productsMenu.psd2Services.personalFinance')}
            description={t('header.productsMenu.psd2Services.personalFinanceDesc')}
            onClick={() => closeMenuFunction()}
          />
        </OnlyFolders>
        <OnlyFolders folders={["it-it"]}>
          <ProductLink to={router('products.psd2Services.bankingAsService', context.folder)}
            label={t('header.productsMenu.psd2Services.bankingAsService')}
            description={t('header.productsMenu.psd2Services.bankingAsServiceDesc')}
            onClick={() => closeMenuFunction()}
          />
        </OnlyFolders>
      </div>

      <div className="h-full p-5 bg-midnight-60">
        <StaticImage src="../../../../assets/images/header/header-bank-coverage.png" alt="bank coverage" />
        <div className="mt-3 text-xs">
          {t('header.productsMenu.psd2Services.bankCoverage')}
        </div>
        <div className="mt-1 text-small">
          {t('header.productsMenu.psd2Services.bankCoverageDesc')}
        </div>
        <ArrowLink to={router('products.psd2Services.bankCoverage', context.folder)} className="py-1" onClick={() => closeMenuFunction()}>
          {t('header.productsMenu.psd2Services.rightButton')}
        </ArrowLink>
      </div>
    </>
  }

  const EndToEndProducts = () => {
    return <div className="h-full px-5 pt-5 pb-3.5 products-list col-span-2">
      <h5 className="text-blue-10 mb-1.5">{t('header.productsMenu.endToEndSolutions.title')}</h5>

      <ProductLink to={router('products.endToEndSolutions.financeOrchestration', context.folder)}
        label={t('header.productsMenu.endToEndSolutions.financeOrchestration')}
        description={t('header.productsMenu.endToEndSolutions.financeOrchestrationDesc')}
        onClick={() => closeMenuFunction()}
      />
      <OnlyFolders folders={["it-it"]}>
        <ProductLink to={router('products.endToEndSolutions.sepa', context.folder)}
          label={t('header.productsMenu.endToEndSolutions.sepa')}
          description={t('header.productsMenu.endToEndSolutions.sepaDesc')}
          onClick={() => closeMenuFunction()}
        />
      </OnlyFolders>
      <ProductLink to={router('products.endToEndSolutions.paymentGate', context.folder)}
        label={t('header.productsMenu.endToEndSolutions.paymentGate')}
        description={t('header.productsMenu.endToEndSolutions.paymentGateDesc')}
        onClick={() => closeMenuFunction()}
      />
      <ProductLink to={router('products.endToEndSolutions.riskAnalysis', context.folder)}
        label={t('header.productsMenu.endToEndSolutions.riskAnalysis')}
        description={t('header.productsMenu.endToEndSolutions.riskAnalysisDesc')}
        onClick={() => closeMenuFunction()}
      />
      <ProductLink to={router('products.endToEndSolutions.guaranteedPayments', context.folder)}
        label={t('header.productsMenu.endToEndSolutions.guaranteedPayments')}
        description={t('header.productsMenu.endToEndSolutions.guaranteedPaymentsDesc')}
        onClick={() => closeMenuFunction()}
      />
      <ProductLink to={router('products.endToEndSolutions.facilitator', context.folder)}
        label={t('header.productsMenu.endToEndSolutions.facilitator')}
        description={t('header.productsMenu.endToEndSolutions.facilitatorDesc')}
        onClick={() => closeMenuFunction()}
      />
      <OnlyFolders folders={["it-it", "en-gb"]}>
        <ProductLink to={router('products.endToEndSolutions.financialSplitPayment', context.folder)}
          label={t('header.productsMenu.endToEndSolutions.financialSplitPayment')}
          description={t('header.productsMenu.endToEndSolutions.financialSplitPaymentDesc')}
          onClick={() => closeMenuFunction()}
        />
      </OnlyFolders>
    </div>
  }

  const BankingProducts = () => {
    return <div className="h-full px-5 pt-5 pb-3.5 col-span-2">
      <h5 className="text-blue-10 mb-1.5">{t('header.productsMenu.bankingServices.title')}</h5>

      <OnlyFolders folders={["it-it"]}>
        <ProductLink to={router('products.bankingServices.businessFinance', context.folder)}
          label={t('header.productsMenu.bankingServices.businessFinance')}
          description={t('header.productsMenu.bankingServices.businessFinanceDesc')}
          onClick={() => closeMenuFunction()}
        />
        <ProductLink to={router('products.bankingServices.smeBanking', context.folder)}
          label={t('header.productsMenu.bankingServices.smeBanking')}
          description={t('header.productsMenu.bankingServices.smeBankingDesc')}
          onClick={() => closeMenuFunction()}
        />
      </OnlyFolders>
      <ProductLink to={router('products.bankingServices.lendingPlace', context.folder)}
        label={t('header.productsMenu.bankingServices.lendingPlace')}
        description={t('header.productsMenu.bankingServices.lendingPlaceDesc')}
        onClick={() => closeMenuFunction()}
      />
      <OnlyFolders folders={["it-it"]}>
        <ProductLink to={router('products.bankingServices.onboarding', context.folder)}
          label={t('header.productsMenu.bankingServices.onboarding')}
          description={t('header.productsMenu.bankingServices.onboardingDesc')}
          onClick={() => closeMenuFunction()}
        />
        <ProductLink to={router('products.bankingServices.checkIban', context.folder)}
          label={t('header.productsMenu.bankingServices.checkIban')}
          description={t('header.productsMenu.bankingServices.checkIbanDesc')}
          onClick={() => closeMenuFunction()}
        />
      </OnlyFolders>
      <ProductLink to={router('products.bankingServices.smartBanking', context.folder)}
        label={t('header.productsMenu.bankingServices.smartBanking')}
        description={t('header.productsMenu.bankingServices.smartBankingDesc')}
        onClick={() => closeMenuFunction()}
      />
    </div>
  }

  const InStoreProducts = () => {
    const externalIcon = <ExternalIcon className="min-w-[16px] min-h-[16px] stroke-midnight-10 inline-block ml-1 relative bottom-[1px]" />

    return <>
      <div className="h-full px-5 pt-5 pb-3.5 products-list">
        <h5 className="text-blue-10 mb-1.5">{t('header.productsMenu.inStoreSolutions.title')}</h5>

        <ProductLink to={router('products.inStoreSolutions.tapToPay', context.folder)}
          label={t('header.productsMenu.inStoreSolutions.tapToPay')}
          description={t('header.productsMenu.inStoreSolutions.tapToPayDesc')}
          onClick={() => closeMenuFunction()}
        />
        <ProductLink blank to={router('products.inStoreSolutions.posEasyCommissioni', context.folder, true)}
          label={t('header.productsMenu.inStoreSolutions.posEasyCommissioni')}
          description={t('header.productsMenu.inStoreSolutions.posEasyCommissioniDesc')}
          onClick={() => closeMenuFunction()}
          icon={externalIcon}
        />
        <ProductLink blank to={router('products.inStoreSolutions.posEasyCanone', context.folder, true)}
          label={t('header.productsMenu.inStoreSolutions.posEasyCanone')}
          description={t('header.productsMenu.inStoreSolutions.posEasyCanoneDesc')}
          onClick={() => closeMenuFunction()}
          icon={externalIcon}
        />
        <ProductLink blank to={router('products.inStoreSolutions.payByLink', context.folder, true)}
          label={t('header.productsMenu.inStoreSolutions.payByLink')}
          description={t('header.productsMenu.inStoreSolutions.payByLinkDesc')}
          onClick={() => closeMenuFunction()}
          icon={externalIcon}
        />
        <ProductLink blank to={router('products.inStoreSolutions.digitalizzazioneContante', context.folder, true)}
          label={t('header.productsMenu.inStoreSolutions.digitalizzazioneContante')}
          description={t('header.productsMenu.inStoreSolutions.digitalizzazioneContanteDesc')}
          onClick={() => closeMenuFunction()}
          icon={externalIcon}
        />
      </div>

      <div className="h-full p-5 bg-midnight-60">
        <StaticImage src="../../../../assets/images/header/header-in-store.png" alt="Tap to pay" />
        <div className="mt-3 text-xs">
          {t('header.productsMenu.inStoreSolutions.rightTitle')}
          <Badge type="blue" className="ml-1 !px-1 !py-0 relative bottom-[3px] !text-12">{t('header.productsMenu.inStoreSolutions.rightBadge')}</Badge>
        </div>
        <div className="mt-1 text-small">
          {t('header.productsMenu.inStoreSolutions.rightDescription')}
        </div>
        <ArrowLink to={router('products.inStoreSolutions.tapToPayIphone', context.folder)} className="py-1" onClick={() => closeMenuFunction()}>
          {t('header.productsMenu.inStoreSolutions.rightButton')}
        </ArrowLink>
      </div>
    </>
  }

  return <>
    <div className="h-full p-3 border-r">
      <div className="relative">
        {/* <div style={{ top: shadowTop, height: shadowHeight + 'px' }} className={`absolute left-0 bg-midnight-60 w-full rounded-lg overflow-hidden z-[10] transition-all duration-100`}></div> */}

        <SubMenuNavlink menuToOpenOnClick={0}>
          <OpenBankingIcon className="min-w-[40px] min-h-[40px]" /><span className={`${currentSubMenu === 0 ? 'text-blue-10' : 'text-midnight-10'} text-large ml-2 font-bold`}>{t('header.productsMenu.psd2Services.title')}</span>
        </SubMenuNavlink>
        <SubMenuNavlink menuToOpenOnClick={1}>
          <OpenPaymentsIcon className="min-w-[40px] min-h-[40px]" /><span className={`${currentSubMenu === 1 ? 'text-blue-10' : 'text-midnight-10'} text-large ml-2 font-bold`}>{t('header.productsMenu.endToEndSolutions.title')}</span>
        </SubMenuNavlink>
        <AllFoldersExcept folders={["es-es"]}>
          <SubMenuNavlink menuToOpenOnClick={2}>
            <OpenFinanceIcon className="min-w-[40px] min-h-[40px]" /><span className={`${currentSubMenu === 2 ? 'text-blue-10' : 'text-midnight-10'} text-large ml-2 font-bold`}>{t('header.productsMenu.bankingServices.title')}</span>
          </SubMenuNavlink>
        </AllFoldersExcept>
        <OnlyFolders folders={["it-it"]}>
          <SubMenuNavlink menuToOpenOnClick={3}>
            <InStoreIcon className="min-w-[40px] min-h-[40px]" /><span className={`${currentSubMenu === 3 ? 'text-blue-10' : 'text-midnight-10'} text-large ml-2 font-bold`}>{t('header.productsMenu.inStoreSolutions.title')}</span>
          </SubMenuNavlink>
        </OnlyFolders>
      </div>
    </div>

    {currentSubMenu === 0 && <Psd2Products />}
    {currentSubMenu === 1 && <EndToEndProducts />}
    {currentSubMenu === 2 && <BankingProducts />}
    {currentSubMenu === 3 && <InStoreProducts />}
  </>
}

export default MenuProducts